export const PoliticSpacesColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
];
